export const donationConstants = {
    DONATE_TO_CAMPAIGN : 'DONATE_TO_CAMPAIGN',   
    PRODUCT_IMPACT : 'PRODUCT_IMPACT',
    AMOUNT_FORMAT  : [], // ["EUR","USD","AED"]
};
export const SET_HBL_CONFIG = 'SET_HBL_CONFIG';
export const SET_TAX_DONATION_MESSAGES = 'SET_TAX_DONATION_MESSAGES';
export const SET_DEFAULT_AMOUNT_OPTIONS = "SET_DEFAULT_AMOUNT_OPTIONS"
